<section id="content">
    <div class="content-wrap m-0 p-0">
        <div class="parallax">
            <div class="section my-0 p-t-65 m-b-60">
                <div class="container">
                    <div [class]="'sitemap-container p-b-30 ' + 'sitemap-' + projectCode">
                        <div class="sitemap-header">
                            <h3 class="border-page-title">{{ 'Sitemap' | translate }}</h3>
                        </div>
                        <hr>
                        <ng-container *ngIf="no_data; else elseTemplate">
                            <div class="no-data-container">
                                <label [class]="'no-data ' + 'no-data-' + projectCode">{{ 'No Data Available' | translate }}</label>
                            </div>
                        </ng-container>
                        <ng-template #elseTemplate>
                            <div class="sitemap-content">
                                <div class="category-section" *ngFor="let category of sortedData">
                                    <div class="category-header">
                                        <h3 class="category-title">{{ intoTitleCase(category.key) | translate }}</h3>
                                    </div>
                                    <div class="provider-list">
                                        <div class="provider-item" *ngFor="let provider of category.value">
                                            <a [routerLink]="['/'+provider.category_path, provider.game_provider_path]">{{ provider.game_provider_name }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>